// Punto de entrada a la base de datos.
//
// El nombre del archivo y del export se conservan a propósito: las ~40 pantallas
// y servicios de la aplicación hacen `import { supabase } from '@/lib/supabase'`.
// Lo que cambia es lo que hay detrás — ya no es Supabase, sino el gateway propio
// contra PostgreSQL en AWS RDS (server/pg/*) — pero la API es la misma, así que
// no hubo que tocar las llamadas existentes.
//
// Ver docs/MIGRACION_RDS.md para el detalle de la migración.

import { createClient } from './db/client';

export const supabase = createClient();

export type {
  AuthChangeEvent,
  AuthError,
  PostgrestError,
  RealtimePostgresChangesPayload,
  Session,
  Subscription,
  User,
} from './db/types';

export { GatewayError } from './db/transport';

/**
 * Tipos de las tablas más usadas. Se mantiene el nombre `Database` porque ya se
 * importaba en algunos módulos.
 */
export type Database = {
  public: {
    Tables: {
      users: {
        Row: {
          id: string;
          email: string;
          full_name: string | null;
          company: string | null;
          phone: string | null;
          address: string | null;
          city: string | null;
          country: string | null;
          position: string | null;
          role: string | null;
          account_type: 'business' | 'accountant';
          company_public_id: string;
          status: string | null;
          plan_id: string | null;
          plan_active: boolean | null;
          plan_ends_at: string | null;
          trial_end: string | null;
          last_sign_in: string | null;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id: string;
          email: string;
          full_name?: string | null;
          company?: string | null;
          phone?: string | null;
          address?: string | null;
          city?: string | null;
          country?: string | null;
          position?: string | null;
          role?: string | null;
          account_type?: 'business' | 'accountant';
          company_public_id?: string;
          status?: string | null;
          plan_id?: string | null;
          plan_active?: boolean | null;
          plan_ends_at?: string | null;
          trial_end?: string | null;
          created_at?: string;
          updated_at?: string;
        };
        Update: Partial<Database['public']['Tables']['users']['Insert']>;
      };
    };
  };
};
